<template lang="html">
  <div class="">
    <si-container>
      <v-flex
        v-if="reportEditActive"
        xs12
        pa-0
        text-center
        mt-4
        mb-6
      >
        <v-dialog
          v-model="publishDialog"
          persistent
          max-width="600px"
        >
          <v-card>
            <v-card-title>
              <div class="">
                <div class="headline">
                  Publish Report
                </div>
                <div class="caption grey--text">
                  Internal use only, will not display on report
                </div>
              </div>
            </v-card-title>
            <v-card-text>
              <v-form
                ref="form"
                v-model="versionInfo"
                @submit.prevent=""
              >
                <v-container
                  grid-list-md
                  pa-0
                >
                  <v-layout wrap>
                    <v-flex xs12>
                      <SiInputText
                        ref="versionsummary"
                        value=""
                        outlined
                        autofocus
                        hide-details
                        label="New version summary"
                        :rules="[_ruleRequired()]"
                        @change="reportEditInfo.summary = $event"
                      />
                      <!-- <v-text-field value="" @change="reportEditInfo.summary = $event" outlined autofocus hide-details label="New version summary" :rules="[_ruleRequired()]" ref="versionsummary"/> -->
                    </v-flex>
                    <v-flex xs12>
                      <SiInputTextarea
                        value=""
                        outlined
                        auto-grow
                        rows="2"
                        hide-details
                        label="New version description"
                        :rules="[_ruleRequired()]"
                        @change="reportEditInfo.description = $event"
                      />
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-spacer />
              <v-btn
                color="grey"
                text
                @click.native="publishDialog = false"
              >
                Cancel
              </v-btn>
              <v-btn
                color="info"
                @click="publishReport"
              >
                <v-icon left>
                  publish
                </v-icon>Publish
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-btn
          color="info"
          class="mx-2"
          @click="callPublish"
        >
          <v-icon left>
            publish
          </v-icon>Publish Report
        </v-btn>
        <v-btn
          text
          color="grey"
          class="mx-2"
          @click="reportEditActive = !reportEditActive"
        >
          Cancel
        </v-btn>
      </v-flex>

      <v-flex
        v-if="!reportEditActive"
        xs12
        text-center
        mt-4
        mb-6
      >
        <v-btn
          color="primary"
          class="mx-2"
          @click="createNewReport"
        >
          <v-icon left>
            add
          </v-icon> Create new version
        </v-btn>
        <v-btn
          color="primary"
          class="mx-2"
          @click="versionDialog = !versionDialog"
        >
          <v-icon left>
            search
          </v-icon>Versions
        </v-btn>
      </v-flex>

      <v-flex
        v-if="reportEditActive"
        pa-0
        pb-4
        class="si-paper"
        style="margin: 0 auto"
      >
        <v-alert
          v-if="!reportEditIsNew"
          type="warning"
          outlined
        >
          <b>Previous version</b>
          <div>
            You are editing a previous version. <br>
            Do not make changes of substance. Updates to data references or spelling only.
          </div>
        </v-alert>

        <v-flex
          xs12
          my-2
          class="title"
        >
          Report Info
        </v-flex>

        <v-form ref="reportform">
          <v-flex xs12>
            <SiInputText
              v-model="reportEdit.title"
              outlined
              autofocus
              hide-details
              label="Report title"
              :rules="[_ruleRequired()]"
            />
          </v-flex>
        </v-form>

        <v-flex
          xs12
          my-2
          class="title"
        >
          Sections
        </v-flex>

        <Container
          lock-axis="y"
          class="flex pa-0"
          drag-handle-selector=".si-drag-handle"
          @drop="onDropSection"
        >
          <Draggable
            v-for="section in _sortObject(reportEdit.sections)"
            :key="section.id"
          >
            <v-flex
              class="white"
              xs12
            >
              <v-card :id="section.id">
                <v-layout
                  align-center
                  fill-height
                  class="ma-0 pa-3"
                >
                  <v-icon
                    left
                    class="cursor-move si-drag-handle"
                  >
                    drag_indicator
                  </v-icon>
                  <v-flex
                    shrink
                    pa-0
                    pr-2
                  >
                    <v-layout align-center>
                      <v-tooltip right>
                        <template #activator="{ on }">
                          <v-icon
                            v-if="section.condition"
                            color="warning"
                            class="cursor-default"
                            left
                            v-on="on"
                          >
                            call_split
                          </v-icon>
                          <v-icon
                            v-else
                            class="cursor-default"
                            left
                          >
                            arrow_upward
                          </v-icon>
                        </template>
                        <SiConditionChips :condition="section.condition" />
                      </v-tooltip>
                      <v-flex
                        :class="{'grey--text font-italic': !section.title}"
                        class=" title"
                      >
                        {{ section.title || 'no title' }}
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-spacer />
                  <v-btn
                    text
                    color="grey"
                    @click="openPanel(section.id)"
                  >
                    {{ panels[section.id] === 0 ? 'Done' : 'Edit' }}
                  </v-btn>
                </v-layout>
                <v-expansion-panels
                  v-model="panels[section.id]"
                  class="si-expansion-panel-flat"
                >
                  <v-expansion-panel expand-icon="edit">
                    <v-expansion-panel-content>
                      <v-container grid-list-md>
                        <v-layout wrap>
                          <v-flex
                            xs12
                            my-2
                          >
                            <v-layout ma-0>
                              <SiConditionEditor
                                v-model="section.condition"
                                :title="`<strong>${section.title}</strong> condition`"
                                :fields="fields"
                              >
                                <template
                                  v-if="!section.condition"
                                  #activator="{ on }"
                                >
                                  <v-btn
                                    text
                                    color="grey"
                                    v-on="on"
                                  >
                                    <v-icon left>
                                      arrow_upward
                                    </v-icon>no conditions
                                  </v-btn>
                                </template>
                              </SiConditionEditor>
                              <SiConditionChips :condition="section.condition" />
                            </v-layout>
                          </v-flex>

                          <v-flex xs12>
                            <SiInputText
                              :ref="`${section.id}_title`"
                              v-model="section.title"
                              outlined
                              autofocus
                              hide-details
                              label="Section title"
                            />
                          </v-flex>
                          <v-flex xs12>
                            <SiInputText
                              :value="section.component"
                              outlined
                              hide-details
                              label="Component name"
                              @change="updateComponent(section.id, $event)"
                            />
                          </v-flex>
                          <v-flex xs12>
                            <SiQuill v-model="section.textPre" />
                          </v-flex>
                          <v-flex
                            v-if="section.component"
                            xs12
                          >
                            <SiQuill v-model="section.textPost" />
                          </v-flex>
                          <v-flex xs12>
                            <SiInputCheckbox
                              v-model="section.canHide"
                              outlined
                              hide-details
                              label="Section can be hidden for printing"
                            />
                          </v-flex>
                          <v-flex
                            xs12
                            text-center
                          >
                            <v-btn
                              color="grey"
                              text
                              @click="removeSection(section.id)"
                            >
                              remove
                            </v-btn>
                          </v-flex>
                        </v-layout>
                      </v-container>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-card>
            </v-flex>
          </Draggable>
        </Container>
        <v-layout
          align-center
          ma-0
          pa-2
        >
          <v-btn
            color="primary"
            text
            @click="addSection"
          >
            <v-icon left>
              add
            </v-icon>add
          </v-btn>
          <v-divider />
        </v-layout>
      </v-flex>

      <v-flex
        v-if="reportEditActive"
        xs12
        my-3
      >
        <v-divider />
      </v-flex>
    </si-container>
    <v-slide-y-transition>
      <Report
        v-if="hasReport"
        :report="{template: previewReport}"
      />
    </v-slide-y-transition>
    <v-dialog
      v-model="versionDialog"
      scrollable
      max-width="600px"
    >
      <v-card>
        <v-card-title primary-title>
          Report Versions
          <v-spacer />
          <v-btn
            text
            icon
            color="grey"
            small
            @click="versionDialog = !versionDialog"
          >
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pa-0">
          <v-list two-line>
            <template v-for="v in _sortObject(versions, 'timestamp').reverse()">
              <v-divider :key="`divider_${v.id}`" />
              <v-list-item
                :key="v.id"
                :class="{'teal lighten-4': (currentVersionId || '').toString() === v.id.toString()}"
                @click="showPrevVersion(v.id)"
              >
                <v-list-item-avatar>
                  <SiUserAvatar
                    size="36"
                    :uid="v.uid || null"
                  />
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title>
                    <v-tooltip bottom>
                      <template #activator="{ on }">
                        <span v-on="on">{{ v.summary }}</span>
                      </template>
                      <div>{{ v.summary }}</div>
                    </v-tooltip>
                  </v-list-item-title>
                  <v-list-item-subtitle>{{ _formatDateTime(v.timestamp) }} <i>{{ v.edits ? `Edited (${v.edits})` : '' }}</i></v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-icon v-if="(currentVersionId || '').toString() === v.id.toString()">
                  <v-icon color="success">
                    done
                  </v-icon>
                </v-list-item-icon>
              </v-list-item>
            </template>
          </v-list>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog
      :value="prevVersionView"
      scrollable
      max-width="780px"
    >
      <v-card>
        <v-card-title primary-title>
          Report Version
          <v-btn
            text
            color="grey"
            class="ml-4"
            @click="editReport(prevVersionView.id)"
          >
            Edit
          </v-btn>
          <v-spacer />
          <v-btn
            text
            icon
            color="grey"
            small
            @click="prevVersionView = null"
          >
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider />
        <v-card-text
          v-if="prevVersionView"
          class="pa-0"
          style="color:inherit"
        >
          <v-flex
            pa-4
            class="grey--text text--darken-4"
          >
            <v-layout>
              <v-flex>
                <div class="caption grey--text ">
                  Id:
                </div>
                <div class="">
                  {{ prevVersionView.id }}
                </div>
                <div class="caption grey--text ">
                  Summary:
                </div>
                <div class="">
                  {{ (prevVersionView.info || {}).summary }}
                </div>
                <div class="caption grey--text mt-2">
                  Description of changes:
                </div>
                <div v-html="_formatLineBreaks((prevVersionView.info || {}).description)" />
              </v-flex>
              <v-flex>
                <div class="caption grey--text">
                  Editor:
                </div>
                <v-layout align-center>
                  <SiUserAvatar
                    size="24"
                    :uid="(prevVersionView.info || {}).uid || false"
                  />
                  <span class="ml-2">{{ _userName((prevVersionView.info || {}).uid) }}</span>
                </v-layout>
                <div class="caption grey--text mt-2">
                  Timestamp:
                </div>
                <div v-html="_formatDate(prevVersionView.timestamp)" />
              </v-flex>
            </v-layout>
            <div />
            <div v-if="prevVersionView.edits">
              <div class="caption grey--text mt-2">
                Edits:
              </div>
              <v-layout
                v-for="edit in prevVersionView.edits"
                :key="edit.timestamp"
                align-center
                style="font-size: 85%"
              >
                <SiUserAvatar
                  size="24"
                  :uid="edit.uid || false"
                  class="mr-4"
                />
                <v-flex
                  shrink
                  pa-2
                  style="white-space:nowrap"
                >
                  {{ _formatDate(edit.timestamp) }}
                </v-flex>
                <v-flex pa-2>
                  {{ edit.summary }}
                </v-flex>
                <v-flex pa-2>
                  {{ edit.description }}
                </v-flex>
              </v-layout>
            </div>
          </v-flex>
          <v-divider class="mb-6" />
          <Report :report="{template: prevVersionView}" />
        </v-card-text>
      </v-card>
    </v-dialog>
    <SiLoaderPopup :value="prevVersionLoading" />
    <v-snackbar
      v-model="reportEditSucess"
      :timeout="2000"
    >
      <div class="text-center">
        {{ reportEditSuccessText }}
      </div>
    </v-snackbar>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { Container, Draggable } from 'vue-smooth-dnd'
import { cloneDeep } from 'lodash'
import helpers from '@/mixins/helpers'
import drag from '@/mixins/drag'
import validation from '@/mixins/validations'
import binder from '@/mixins/binder'
import users from '@/mixins/users'
import uniqid from 'uniqid'

import { rtdb } from '@/plugins/firebase'
export default {
  components: { Container, Draggable },
  mixins: [ helpers, drag, validation, binder, users ],
  props: {
    calculatorId: String,
    fields: Object
  },
  data () {
    return {
      dbRef: null,
      report: {},
      reportSections: [],
      reportEdit: {},
      reportEditInfo: {},
      reportEditActive: false,
      reportEditIsNew: true,
      reportEditSucess: false,
      reportEditSuccessText: '',
      versionInfo: false,
      publishDialog: false,
      versionDialog: false,
      prevVersionViewDialog: false,
      prevVersionView: null,
      prevVersionLoading: false,
      versions: {},
      panels: {}
    }
  },
  computed: {
    ...mapGetters(['_user']),
    sortredinternalSections: {
      get () {
        return this._sortObject(this.reportEdit.sections)
      },
      set (v) {
        v.forEach((section, i) => {
          section.index = i
        })
        this.reportEdit.sections = this._unSortObject(v)
      }
    },
    hasReport () {
      return (this.previewReportSections || []).length > 0 || Object.keys(this.previewReport).length > 0
    },
    previewReport () {
      return this.reportEditActive ? this.reportEdit : this.report || {}
    },
    currentVersionId () {
      return this.report.id
    },
    editInfo () {
      return { ...this.reportEditInfo, ...{ uid: this._user.uid } }
    }
  },
  watch: {
    '$route.params.sub' () {
      this.bindReport()
    }
  },
  beforeMount () {
    this.bindReport()
  },
  methods: {
    bindReport () {      
      this.reportEditActive = false
      this.report = {}
      this.reportSections = []

      const callback = (v) => {
        this.report = v
        this.reportSections = this._sortObject(v.sections)
      }

      this.$bindRtdb('versions', `calculators/${this.calculatorId}/report/_list`)

      this.$bindRtdb('report', `calculators/${this.calculatorId}/report/activeVersion`, { callback, loader: true })

      // this.$unbindAll()

      // this.$bindxxx(rtdb.ref(`calculators/${this.calculatorId}/report/_list`), 'versions')

      // this.$bindxxx(rtdb.ref(`calculators/${this.calculatorId}/report/activeVersion`), v => {
      //   this.report = v
      //   this.reportSections = this._sortObject(v.sections)
      // }, true)
    },
    updateComponent (id, e) {
      this.$set(this.reportEdit.sections, id, Object.assign({}, this.reportEdit.sections[id], { component: e }))
    },
    openPanel (sectionId) {
      if (this.panels[sectionId] === 0) {
        this.panels[sectionId] = -1
      } else {
        this.$set(this.panels, sectionId, 0)
      }
    },
    onDropSection (e) {
      this.sortredinternalSections = this._applyDrag(this.sortredinternalSections, e)
      // this.reportEdit.sections.forEach((s, i) => {s.index = i})
    },
    addSection () {
      let id = uniqid()
      let i = (this.reportEdit.sections || []).length
      let d = { index: i, id: id }
      // if (!this.reportEdit.sections) this.$set(this.newRepor, 'sections', {})
      this.$set(this.reportEdit.sections, id, d)
      this.openPanel(id)
      requestAnimationFrame(() => {
        this.$vuetify.goTo(`#${id}`)
        this.$refs[`${id}_title`][0].focus()
      })
    },
    removeSection (id) {
      this.$delete(this.reportEdit.sections, id)
    },
    editorChange (i, key, content) {
      let cleanContent = Object.assign({}, content)
      delete cleanContent.quill

      let d = Object.assign({}, this.reportEdit.sections[i])
      d[key] = cleanContent.html

      this.$set(this.reportEdit.sections, i, d)
      this.reportEdit.sections[i][key] = cleanContent.html
    },
    createNewReport () {
      this.reportEditIsNew = true
      this.reportEditActive = true
      this.reportEdit = cloneDeep(this.report)
      if (!this.reportEdit.sections) this.$set(this.reportEdit, 'sections', {})
    },
    editReport (id) {
      this.reportEditIsNew = false
      this.reportEditActive = true
      this.prevVersionView = null
      this.versionDialog = false
      rtdb.ref(`calculators/${this.calculatorId}/report/versions/${id}`).once('value', s => {
        this.reportEdit = s.val()
      })
    },
    callPublish () {
      if (!this.$refs.reportform.validate()) return
      this.publishDialog = true
      requestAnimationFrame(() => {
        this.$refs['versionsummary'].focus()
      })
    },
    publishReport () {
      if (this.reportEditIsNew) {
        this.publishNewReport()
      } else {
        this.publishExistingReport()
      }
    },
    publishExistingReport () {
      let dateStamp = new Date()
      let timestamp = dateStamp.toISOString()
      let updates = {}
      let { id, title, sections, edits = {} } = this.reportEdit
      let editsCount = Object.keys(edits).length

      updates[`calculators/${this.calculatorId}/report/versions/${id}/sections`] = sections
      updates[`calculators/${this.calculatorId}/report/versions/${id}/title`] = title
      updates[`calculators/${this.calculatorId}/report/versions/${id}/edits/${Number(dateStamp)}`] = {...this.editInfo, timestamp}
      updates[`calculators/${this.calculatorId}/report/_list/${id}/edits`] = editsCount + 1
      if (id === this.report.id) {
        // report is active version
        updates[`calculators/${this.calculatorId}/report/activeVersion/sections`] = sections
        updates[`calculators/${this.calculatorId}/report/activeVersion/title`] = title
      }
      this.reportEditActive = false
      this.publishDialog = false
      this.reportEditInfo = {}
      this.reportEdit = {}
      rtdb.ref().update(updates).then(() => {
        this.bindReport()
        this.reportEditSucess = true
        this.reportEditSuccessText = 'Report version was updated'
      })
    },
    publishNewReport () {
      if (!this.$refs.form.validate()) return

      let dateStamp = new Date()
      let id = Number(dateStamp)
      let timestamp = dateStamp.toISOString()
      let report = Object.assign({}, this.reportEdit, { id: id, timestamp: timestamp })
      let info = this.editInfo
      let index = {
        id: id,
        uid: this._user.uid,
        timestamp: timestamp,
        title: this.reportEdit.title,
        summary: this.reportEditInfo.summary
        // _disabled: 
      }
      report = this._removeUndefined(report)
      index = this._removeUndefined(index)

      var updates = {}
      updates[`calculators/${this.calculatorId}/report/activeVersion`] = report
      updates[`calculators/${this.calculatorId}/report/versions/${id}`] = Object.assign({}, report, { info })
      updates[`calculators/${this.calculatorId}/report/_list/${id}`] = index
      updates[`calculators/${this.calculatorId}/report/activeVersionId`] = id

      this.reportEditActive = false
      this.publishDialog = false
      this.reportEditInfo = {}
      this.reportEdit = {}

      rtdb.ref().update(updates).then(() => {
        this.bindReport()
        this.reportEditSucess = true
        this.reportEditSuccessText = 'New report version was created'
      })
    },
    showPrevVersion (id) {
      this.prevVersionLoading = true
      rtdb.ref(`calculators/${this.calculatorId}/report/versions/${id}`).once('value', s => {
        this.prevVersionView = s.val()
        this.prevVersionLoading = false
      })
    }
  }
}
</script>

<style lang="css">
.ql-editor{
    min-height:100px !important;
}
</style>
